<template>
  <div id="serve">
    <div class="headerImg">
      <img
        class="img"
        src="@/assets/gzh/测试图片.webp"
        alt=""
        style="width: 94%; height: 132px"
      />
    </div>
    <div class="shopContent" v-for="(item, index) in channelList" :key="index">
      <div class="title">{{ item.moduleName }}</div>
      <div class="content">
        <div class="contentItem" v-for="i in item.servicesList" :key="i.id">
          <a :href="i.jumpLink" style="color: #000">
            <img class="shopImg" :src="`${uploadUrl}${i.imgUrl}`" alt="" />
            <div class="imgTitle">{{ i.serviceName }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "serve",
  data() {
    return {
      uploadUrl: "",
      channelList: {}
    };
  },
  created() {},
  mounted() {
    document.title = "服务";
    this.uploadUrl = apis.uploadUrl;
    this.getChannelList();
  },
  methods: {
    // 获取数据
    getChannelList() {
      apis.dataList().then(res => {
        if (res.code === 200) {
          for (let key in res.data) {
            res.data[key].servicesList.map(item => {
              if (item.jumpLink.indexOf("http") !== -1) {
                item.jumpLink = "http" + item.jumpLink.split("http")[1];
              }
              if (item.jumpLink.indexOf("https") !== -1) {
                item.jumpLink = "https" + item.jumpLink.split("https")[1];
              }
              return item;
            });
          }
          this.channelList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #serve {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #serve {
    width: 276px * $zoom;
  }
}
#serve {
  font-size: 16px * $zoom;
  .headerImg {
    text-align: center;
    margin-bottom: 20px;
    margin: 20px 0;
  }
  .shopContent {
    padding: 10px 0 20px 0;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0px;
    }
    .title {
      width: 260px;
      height: 37px;
      font-size: 29px;
      border-left: 10px solid #00c688;
      padding-left: 15px;
      margin: 0 20px 20px 3.4%;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .contentItem {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .shopImg {
          width: 90px;
          height: 90px;
          margin-bottom: 10px;
        }
        .imgTitle {
          font-size: 20px;
          width: 90px;
          text-align: center;
        }
      }
    }
  }
}
</style>
